import { useOutletContext } from "react-router-dom";

import type {
  AppBootstrapOutletContext,
  RootOutletContext,
} from "../shared/outletContextsTypes";

import { RedirectControlSurvey } from "../pages/RedirectControlSurvey";
import { FinishedControlSurvey } from "../pages/FinishedControlSurvey";
import { ContentPage } from "../pages/ContentPage/ContentPage";
import MentorPal from "../pages/Mentorpal/MentorPal";
import RecommenderPage from "../pages/RecommenderPage/RecommenderPage";

export function RedirectControlSurveyRoute() {
  const { canvasId } = useOutletContext<RootOutletContext>();

  return <RedirectControlSurvey canvasId={canvasId ?? ""} />;
}

export function CompletedControlSurveyRoute() {
  const { submittingGrade, gradePosted } =
    useOutletContext<RootOutletContext>();

  return (
    <FinishedControlSurvey
      submittingGrade={submittingGrade}
      gradePosted={gradePosted}
    />
  );
}

export function ContentPageRoute() {
  const { completedPreSurvey, isLtikSession } =
    useOutletContext<AppBootstrapOutletContext>();

  return (
    <ContentPage
      completedPreSurvey={completedPreSurvey}
      isLtikSession={isLtikSession}
    />
  );
}

export function MentorPalRoute() {
  const { completedPostSurvey, isResearchParticipant } =
    useOutletContext<AppBootstrapOutletContext>();

  return (
    <MentorPal
      completedPostSurvey={completedPostSurvey}
      isResearchParticipant={isResearchParticipant}
    />
  );
}

export function RecommenderPageRoute() {
  const {
    gradePosted,
    submittingGrade,
    completedPostSurvey,
    isResearchParticipant,
  } = useOutletContext<AppBootstrapOutletContext>();

  return (
    <RecommenderPage
      gradePosted={gradePosted}
      submittingGrade={submittingGrade}
      completedPostSurvey={completedPostSurvey}
      isResearchParticipant={isResearchParticipant}
    />
  );
}
